/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VehicleGroupUpdate
 */
export interface VehicleGroupUpdate {
    /**
     * 
     * @type {string}
     * @memberof VehicleGroupUpdate
     */
    label?: string | null;
    /**
     * `UserGroup`s for which new assignments should be created.
     * @type {Array<string>}
     * @memberof VehicleGroupUpdate
     */
    addUserGroupIds?: Array<string> | null;
    /**
     * `UserGroup` for which existing assignments should be removed.
     * @type {Array<string>}
     * @memberof VehicleGroupUpdate
     */
    removeUserGroupIds?: Array<string> | null;
    /**
     * `Vehicle`s for which new assignments should be created.
     * @type {Array<string>}
     * @memberof VehicleGroupUpdate
     */
    addVehicleIds?: Array<string> | null;
    /**
     * `Vehicle`s for which existing assignments should be removed.
     * @type {Array<string>}
     * @memberof VehicleGroupUpdate
     */
    removeVehicleIds?: Array<string> | null;
}

/**
 * Check if a given object implements the VehicleGroupUpdate interface.
 */
export function instanceOfVehicleGroupUpdate(value: object): value is VehicleGroupUpdate {
    return true;
}

export function VehicleGroupUpdateFromJSON(json: any): VehicleGroupUpdate {
    return VehicleGroupUpdateFromJSONTyped(json, false);
}

export function VehicleGroupUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleGroupUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'] == null ? undefined : json['label'],
        'addUserGroupIds': json['addUserGroupIds'] == null ? undefined : json['addUserGroupIds'],
        'removeUserGroupIds': json['removeUserGroupIds'] == null ? undefined : json['removeUserGroupIds'],
        'addVehicleIds': json['addVehicleIds'] == null ? undefined : json['addVehicleIds'],
        'removeVehicleIds': json['removeVehicleIds'] == null ? undefined : json['removeVehicleIds'],
    };
}

export function VehicleGroupUpdateToJSON(json: any): VehicleGroupUpdate {
    return VehicleGroupUpdateToJSONTyped(json, false);
}

export function VehicleGroupUpdateToJSONTyped(value?: VehicleGroupUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
        'addUserGroupIds': value['addUserGroupIds'],
        'removeUserGroupIds': value['removeUserGroupIds'],
        'addVehicleIds': value['addVehicleIds'],
        'removeVehicleIds': value['removeVehicleIds'],
    };
}

